import axiosInstance from "api/axiosInstance"
import { provinceAction } from "./province-slice"
import SAlert from "components/Alert"
import exportAxiosInstance from "api/exportAxiosInstance"
import FileSaver from "file-saver"

export const getProvinces =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  dispatch => {
    dispatch(provinceAction.setLoading(true))
    url = url || "/v1/provinces"
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
        },
      })
      .then(response => {
        if (response) {
          dispatch(provinceAction.setError(null))
          dispatch(provinceAction.setData(response.data))
          dispatch(provinceAction.setLoading(false))
        }
      })
      .catch(error => {
        dispatch(provinceAction.setLoading(false))
        console.log(error)
      })
  }

export const updateProvince = (id, data, navigate) => dispatch => {
  dispatch(provinceAction.setLoading(true))
  axiosInstance
    .post(`/v1/provinces/${id}/update`, data)
    .then(respnose => {
      navigate("/provinces")
      SAlert({ title: "Success", text: "Province successfully updated" })
      dispatch(provinceAction.setError(null))
      dispatch(provinceAction.setLoading(false))
    })
    .catch(error => {
      dispatch(provinceAction.setLoading(false))
      dispatch(provinceAction.setError(error?.response?.data?.errors))
    })
}

export const getByIdProvince = id => dispatch => {
  dispatch(provinceAction.setLoading(true))
  axiosInstance
    .get(`/v1/provinces/${id}`)
    .then(respnose => {
      dispatch(provinceAction.setError(null))
      dispatch(provinceAction.setLoading(false))
      dispatch(provinceAction.setProvince(respnose?.data))
    })
    .catch(error => {
      dispatch(provinceAction.setLoading(false))
      console.log(error)
    })
}

export const exportProvinces = search => dispatch => {
  dispatch(
    provinceAction.setExportStatus({
      loading: true,
      error: null,
    })
  )
  exportAxiosInstance
    .get("/v1/province-export", {
      params: { search },
    })
    .then(response => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        })
        FileSaver.saveAs(dataBlob, `Projects-${Math.random().toString()}.xlsx`)
        dispatch(
          provinceAction.setExportStatus({
            loading: false,
            error: null,
          })
        )
      }
    })
    .catch(error => {
      dispatch(
        provinceAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      )
      console.log(error)
    })
}
